// Library Imports
import Route from 'vue-routisan'
// Guard Imports
import authenticated from './guards/authenticated'
import configured from './guards/configured'
import installed from './guards/installed'

// Autoimport components
Route.setViewResolver((component) => {
  return require(`../views/${component}`).default
})

Route.view('/login', 'Login').name('Login')
  .options({
    meta: { layout: 'canvas' }
  })

// Routes that require an authenticated user
Route.group({ beforeEnter: [authenticated] }, () => {
  Route.view('/installation', 'Installation').name('Installation')
    .options({
      meta: { layout: 'canvas' }
    })

  Route.view('/logout', 'Logout').name('Logout')
})

// Routes that require an authenticated user, an installed register & a configured register
Route.group({ beforeEnter: [authenticated, installed, configured] }, () => {
  Route.view('/', 'Cart').name('Cart')
  Route.view('/settings', 'cash-registers/Settings').name('CashRegistersSettings')

  // CASHREGISTERS GROUP
  Route.group({ prefix: '/registers' }, () => {
    Route.view('/open-close', 'cash-registers/OpenClose').name('CashRegistersOpenClose')
    Route.view('/cash-management', 'cash-registers/CashManagement').name('CashRegistersCashManagement')
    Route.view('/closures', 'cash-register-reports/Index').name('CashRegisterReportsIndex')
  })

  // CUSTOMERS GROUP
  Route.group({ prefix: '/customers' }, () => {
    Route.view('/', 'customers/Index').name('CustomersIndex')
    Route.view('/add', 'customers/Add').name('CustomersAdd')
  })

  // VapeVault GROUP
  Route.group({ prefix: '/vapevault' }, () => {
    Route.view('/', 'VapeVault').name('VapeVault')
  })

  // RECEIPTS GROUP
  Route.group({ prefix: '/receipts' }, () => {
    Route.view('/', 'receipts/Index').name('ReceiptsIndex')
    Route.view('/parked', 'receipts/Parked').name('ReceiptsParked')
  })

  // PRODUCTS GROUP
  Route.group({ prefix: '/products' }, () => {
    Route.view('/', 'products/Index').name('ProductsIndex')
    Route.view('/tag/:tag', 'products/Tag').name('ProductsTag')
  })

  // INVENTORYCOUNTS GROUP
  Route.group({ prefix: '/inventory-counts' }, () => {
    Route.view('/', 'inventory-counts/Index').name('InventoryCountsIndex')
    Route.view('/:uuid/count', 'inventory-counts/Counter').name('InventoryCountsCount')
  })
})

// No matching route found
Route.view('*', 'NotFound')

export default Route.all()



// WEBPACK FOOTER //
// ./src/router/routes.js